import * as React from 'react'
import OfferPageDispatchContext from './offerPageDispatchContext'
import OfferPageStateContext from './offerPageStateContext'
import type { OfferPageDispatchAction, OfferPageState } from './offerPageStateReducer'
import ModalProvider from 'contexts/ModalProvider'
import { useReportContextToDevPanel } from 'components/App/DevPanel/hooks'

interface Props {
  state: OfferPageState
  dispatch: React.Dispatch<OfferPageDispatchAction>
  children: React.ReactNode
}

export function OfferPageStateProvider(props: Props) {
  useReportContextToDevPanel('OfferPageStateContext', props.state)

  return <OfferPageStateContext.Provider value={props.state}>
    <OfferPageDispatchContext.Provider value={props.dispatch}>
      <ModalProvider>
        <ModalProvider>
          {props.children}
        </ModalProvider>
      </ModalProvider>
    </OfferPageDispatchContext.Provider>
  </OfferPageStateContext.Provider>
}

export default OfferPageStateProvider
